// Registered clients ("Your investors", ID-36).

export const CLIENT_NAME_MIN_LENGTH = 2;
export const CLIENT_NAME_MAX_LENGTH = 80;
export const CLIENT_NOTES_MAX_LENGTH = 2000;
export const CLIENT_EMAIL_MAX_LENGTH = 254;
export const CLIENT_PROJECT_TEXT_MAX_LENGTH = 120;
export const CLAIM_NOTE_MAX_LENGTH = 1000;

export const CLIENT_LIST_DEFAULT_LIMIT = 20;
export const CLIENT_LIST_MAX_LIMIT = 50;
export const CLIENT_SEARCH_MAX_LENGTH = 80;
export const CLIENT_CLAIMS_LIST_LIMIT = 100;

// Months since the last purchase before a client is suggested as a repeat buyer.
export const REPEAT_BUY_MIN_MONTHS = 6;

// Used for deal phones typed without a country code (Dubai agents' default).
export const CLIENT_DEFAULT_PHONE_REGION = 'AE';

export const REMOVED_CLIENT_NAME = 'Removed client';
export const UNNAMED_CLIENT_NAME = 'Unnamed client';

export const CLIENT_BUDGET_RANGES = ['under_1m', '1m_2m', '2m_5m', '5m_plus'] as const;
export const CLIENT_INTENTS = ['live_in', 'rent_out', 'resale_profit'] as const;
export const CLIENT_SOURCES = ['post', 'contact', 'referral', 'other'] as const;
export const CLIENT_MANUAL_STATUSES = ['NEW', 'TALKING', 'VIEWING'] as const;
export const CLIENT_LIST_STATUSES = ['new', 'talking', 'viewing', 'bought', 'bought_again'] as const;
export const CLIENT_LIST_SORTS = ['recent', 'name', 'earnings'] as const;
export const CLIENT_CLAIM_DECISIONS = ['keep_holder', 'move_to_claimant'] as const;

// Deal statuses that count as a purchase: TOKEN_UPLOADED or later.
export const CLIENT_PURCHASE_DEAL_STATUSES = [
  'TOKEN_UPLOADED',
  'BOOKING_FORM_UPLOADED',
  'SPA_PENDING',
  'VERIFIED',
  'PAID',
] as const;

// A deal's client can be changed only before it moves past TOKEN_UPLOADED (A6).
export const CLIENT_RELINKABLE_DEAL_STATUSES = ['CONSULTANT_ASSIGNED', 'TOKEN_UPLOADED'] as const;
